// This file is generated by Style Dictionary
const tokens = {
  black: '#000000',
  emperor: '#545454',
  dimGrey: '#616161',
  alto: '#d2d2d2',
  gainsboro: '#e0e0e0',
  galleryGrey: '#efefef',
  whisper: '#eeeeee',
  wildSand: '#f4f4f4',
  whiteSmoke: '#f5f5f5',
  greyFifty: '#fafafa',
  white: '#ffffff',
  fire: '#b93a00',
  guardsmanRed: '#d50000',
  pomegranate: '#f44336',
  royalPurple: '#7451eb',
  orange: '#ff5522',
  macaronyAndCheese: '#ffcc75',
  blueStone: '#005662',
  blueLagoon: '#00838f',
  spray: '#84e5f2',
  congressBlue: '#004c8c',
  lochmara: '#0173b8',
  anakiwa: '#90d6ff',
  cobalt: '#0039cb',
  blueRibbon: '#304ffe',
  pattendsBlue: '#dff1ff',
  prussianBlue: '#002545',
  regalBlue: '#004d71',
  burnham: '#00251a',
  aquaDeep: '#004d40',
  aquaIsland: '#98daca',
  crusoe: '#005005',
  seaGreen: '#2e7e32',
  grannyAppleSmith: '#91df8c',
  teal: '#008577',
  navyBlue: '#140078',
  darkBlue: '#0026ca',
  daisyBush: '#512da8',
  mauve: '#edbfff',
  mediumPurple: '#8559da',
  seance: '#790e8b',
  amethyst: '#ab47bc',
  pinkLace: '#ffddff',
  paprika: '#a00037',
  amaranth: '#d81b60',
  sangria: '#9a0007',
  mojo: '#d32f2f',
  romantic: '#ffcab6',
  springGreen: '#00eda2',
  midnightBlue: '#003668',
  brightBlue: '#00f8f6',
  pink: '#ffe7ea',
  cpfBlue: '#164194',
  ironstone: '#795548',
  portica: '#f6ef59',
};
export default tokens;
